import React from "react";
import { Icon } from "@iconify/react/dist/iconify.js";

/**
 * A window of page numbers, not all of them.
 *
 * With millions of rows there can be tens of thousands of pages, and rendering
 * one button per page would be both unusable and slow. Five around the current
 * one, with the ends always reachable, is what the design's own pager does.
 */
function pageWindow(page, total) {
  if (total <= 7) return Array.from({ length: total }, (_, i) => i + 1);
  const out = [1];
  const from = Math.max(2, page - 1);
  const to = Math.min(total - 1, page + 1);
  if (from > 2) out.push("…");
  for (let p = from; p <= to; p += 1) out.push(p);
  if (to < total - 1) out.push("…");
  out.push(total);
  return out;
}

const Pager = ({ page, totalPages, onPage }) => {
  if (totalPages <= 1) return null;
  return (
    <div className="ms-pager">
      <button
        type="button"
        onClick={() => onPage(Math.max(1, page - 1))}
        disabled={page === 1}
        aria-label="Oldingi"
      >
        <Icon icon="tabler:chevron-left" />
      </button>

      {pageWindow(page, totalPages).map((p, i) =>
        p === "…" ? (
          <span key={`gap-${i}`}>…</span>
        ) : (
          <button
            type="button"
            key={p}
            className={p === page ? "is-active" : ""}
            onClick={() => onPage(p)}
          >
            {p}
          </button>
        ),
      )}

      <button
        type="button"
        onClick={() => onPage(Math.min(totalPages, page + 1))}
        disabled={page === totalPages}
        aria-label="Keyingi"
      >
        <Icon icon="tabler:chevron-right" />
      </button>
    </div>
  );
};

export default Pager;
